import { render, staticRenderFns } from "./WhiteDialog.vue?vue&type=template&id=5b084a6d&scoped=true"
import script from "./WhiteDialog.vue?vue&type=script&lang=js"
export * from "./WhiteDialog.vue?vue&type=script&lang=js"
import style0 from "./WhiteDialog.vue?vue&type=style&index=0&id=5b084a6d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b084a6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b084a6d')) {
      api.createRecord('5b084a6d', component.options)
    } else {
      api.reload('5b084a6d', component.options)
    }
    module.hot.accept("./WhiteDialog.vue?vue&type=template&id=5b084a6d&scoped=true", function () {
      api.rerender('5b084a6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/WhiteDialog.vue"
export default component.exports